/**
 * Kazakan Tools — Aim Assist Training Lab Entry Point
 * Pure client-side 3D FPS aim training utility with Three.js
 */

import { initAimAssistApp } from './aim-assist-training/aim-assist-app.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAimAssistApp('aim-training-app'));
} else {
  initAimAssistApp('aim-training-app');
}
